
import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import ShareMediaPackageForm from './ShareMediaPackageForm.vue'

@Component({
  components: {
    ShareMediaPackageForm,
  },
})
export default class MediaPropertyEdit extends ViewModel {
  @Prop()
  public id!: string

  @Prop()
  public model_id!: string
}
